import { all } from 'redux-saga/effects';
import getProfileWatcher from './profileScreenSaga';

export default function* rootSaga(action) {
	yield all([getProfileWatcher(action)]);
}
